import { common } from '@mui/material/colors';
import { alpha } from '@mui/material/styles';

import { error, indigo, info, neutral, success, warning } from './colors';

export const palette = {
  text: {
    default: '',
    placeholder: '#6B7280',
    highlight: '#008FE1',
    primary: neutral[900],
    secondary: neutral[500],
    disabled: alpha(neutral[900], 0.38),
    charcoal: '#374151',
    dark: '#111928',
  },
  background: {
    default: common.white,
    paper: common.white,
    button: '#009EFA',
  },
  action: {
    active: neutral[500],
    disabled: alpha(neutral[900], 0.38),
    disabledBackground: alpha(neutral[900], 0.12),
    focus: alpha(neutral[900], 0.16),
    hover: alpha(neutral[900], 0.04),
    selected: alpha(neutral[900], 0.12),
    hoverOpacity: 0.04,
    selectedOpacity: 0.3,
    disabledOpacity: 0.38,
    focusOpacity: 0.3,
    activatedOpacity: 1,
  },
  divider: '#F2F4F7',
  error,
  info,
  neutral,
  primary: indigo,
  success,
  warning,
};
